import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { type ShowWithDetails } from "@shared/schema";
import { useAuth } from "@/lib/auth";
import { formatDate } from "@/modules/calculator";
import ShowDetail from "@/components/show-detail";

interface ShowModalProps {
  show: ShowWithDetails | null;
  isOpen: boolean;
  onClose: () => void;
  onAddToProposal: (show: ShowWithDetails) => void;
}

export default function ShowModal({ show, isOpen, onClose, onAddToProposal }: ShowModalProps) {
  const { user } = useAuth();

  if (!show) return null;

  // Use shared UTC-safe date formatter

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-5xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>{show.artist.name} - {formatDate(show.date)}</DialogTitle>
          <DialogDescription>
            {show.venue.name} in {show.venue.city}, {show.venue.state}
          </DialogDescription>
        </DialogHeader>
        
        <ShowDetail 
          show={show}
          onAddToProposal={onAddToProposal}
          isAuthenticated={!!user}
        />
      </DialogContent>
    </Dialog>
  );
}
